import React from 'react'

const GenericAuto = () => (
  <svg
    id="Livello_1"
    version="1.1"
    viewBox="0 0 100 100"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
  >
    <circle className="svg--red" cx="50.2" cy="45.5" r="40.8" />
    <g>
      <path
        className="svg--white"
        d="M77.6,54.8h-0.5L72.9,36c-0.2-1-1.1-1.7-2.1-1.7h-41c-1,0-1.9,0.7-2.1,1.7l-4.1,18.9h-0.5
                    c-3.7,0-6.7,3-6.7,6.6l-0.2,18.3c0,0,0,0,0,0c0,3.7,3,6.7,6.7,6.7h2.5v2.3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7v-2.3h23.2v2.3
                    c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7v-2.3h2.3c3.7,0,6.7-3,6.7-6.7V61.5C84.2,57.8,81.2,54.8,77.6,54.8z"
      />
      <g>
        <path
          className="svg--gray"
          d="M30.9,65.1c-2.7,0-5.5,1.9-5.5,5.5c0,1.7,0.6,3.1,1.8,4.2c1,0.9,2.3,1.4,3.8,1.4c2.7,0,5.5-1.9,5.5-5.5
                      C36.5,67.1,33.6,65.1,30.9,65.1z M30.9,71.9c-0.5,0-1.2-0.2-1.2-1.2c0-1.1,0.8-1.2,1.2-1.2c0.3,0,0.7,0.1,0.9,0.3
                      c0.1,0.1,0.3,0.3,0.3,0.9C32.1,71.7,31.4,71.9,30.9,71.9z"
        />
        <path
          className="svg--gray"
          d="M69.7,65.1c-2.7,0-5.5,1.9-5.5,5.5c0,1.7,0.6,3.1,1.8,4.2c1,0.9,2.3,1.4,3.8,1.4c2.7,0,5.5-1.9,5.5-5.5
                      C75.2,67.1,72.4,65.1,69.7,65.1z M69.7,71.9c-0.5,0-1.2-0.2-1.2-1.2c0-1.1,0.8-1.2,1.2-1.2c0.3,0,0.7,0.1,0.9,0.3
                      c0.1,0.1,0.3,0.3,0.3,0.9C70.9,71.7,70.1,71.9,69.7,71.9z"
        />
        <path
          className="svg--gray"
          d="M69.8,58.4c0.4-0.5,0.6-1.2,0.4-1.8l-2.9-13.7c-0.2-1-1.1-1.7-2.1-1.7H35.4c-1,0-1.9,0.7-2.1,1.7l-3.1,13.7
                      c-0.1,0.6,0,1.3,0.4,1.8c0.4,0.5,1,0.8,1.7,0.8h35.7C68.7,59.2,69.4,58.9,69.8,58.4z M35.1,54.8l2.1-9.3h26.3l2,9.3H35.1z"
        />
        <path
          className="svg--gray"
          d="M77.6,54.8h-0.5L72.9,36c-0.2-1-1.1-1.7-2.1-1.7h-41c-1,0-1.9,0.7-2.1,1.7l-4.1,18.9h-0.5
                      c-3.7,0-6.7,3-6.7,6.6l-0.2,18.3c0,0,0,0,0,0c0,3.7,3,6.7,6.7,6.7h2.5v2.3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7v-2.3h23.2v2.3
                      c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7v-2.3h2.3c3.7,0,6.7-3,6.7-6.7V61.5C84.2,57.8,81.2,54.8,77.6,54.8z M34.4,88.8
                      c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-2.3h4.7V88.8z M70.9,88.8c0,1.4-1.2,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-2.3h4.7V88.8z
                       M79.9,79.8c0,1.3-1,2.3-2.3,2.3H22.9c-1.3,0-2.3-1-2.3-2.3l0.2-18.3c0-1.3,1-2.3,2.3-2.3h2.3c1,0,1.9-0.7,2.1-1.7l4.1-18.9h37.5
                      l4.1,18.9c0.2,1,1.1,1.7,2.1,1.7h2.3c1.3,0,2.3,1,2.3,2.3V79.8z"
        />
      </g>
      <g>
        <path
          className="svg--gray"
          d="M54.9,75c-1,0-1.7-0.8-1.7-1.7c0-2.2-1.8-2.9-2.9-2.9c-1.2,0-3,0.8-3,2.9c0,1-0.8,1.7-1.7,1.7
                      c-1,0-1.7-0.8-1.7-1.7c0-4,3.3-6.4,6.4-6.4c3.2,0,6.4,2.4,6.4,6.4C56.6,74.2,55.9,75,54.9,75z"
        />
      </g>
    </g>
  </svg>
)

export default GenericAuto
